import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FederationContext, OrganisationContext } from '@/context';
import { useQuery } from '@/hooks';
import { GET_FEDERATION_SCHEMES } from '@/queries';
import SchemeSettings from '../../../components/Settings/Scheme';

const OrganisationSchemeSettingsContainer = () => {
  const federation = useContext(FederationContext);
  const organisation = useContext(OrganisationContext);
  const navigate = useNavigate();
  const {
    loading,
    data: schemes,
    error,
  } = useQuery(GET_FEDERATION_SCHEMES, {
    selector: 'federations[0].schemes',
    variables: {
      federationKey: federation.key,
    },
  });

  return (
    <SchemeSettings
      error={error}
      loading={loading}
      schemes={schemes}
      onSchemeSelected={(schemeId) => {
        navigate(`/${organisation.key}/settings/template/${schemeId}`);
      }}
    />
  );
};

export default OrganisationSchemeSettingsContainer;
